import { render, staticRenderFns } from "./booking.vue?vue&type=template&id=fa93b38c&scoped=true"
import script from "./booking.vue?vue&type=script&lang=js"
export * from "./booking.vue?vue&type=script&lang=js"
import style0 from "./booking.vue?vue&type=style&index=0&id=fa93b38c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fa93b38c",
  null
  
)

export default component.exports